import cn from 'classnames';
import type { IColumn } from '@creditflowresearch/uilib/Table/DataTable/interfaces/Column';
import type { IApiColumnConfig } from '@/creditflowresearch/domain/vo/Bondscreener';
import type { IColumnDefinition, IColumnRendererEntry } from './types';
import { resolveColumnFromApiConfig } from './resolveColumnFromApiConfig';
import { resolveAlignment } from './resolveAlignment';

type TGetDataField = (apiColumnId: string) => string;

const defaultGetDataField: TGetDataField = (apiColumnId) => apiColumnId;

export const resolveDataColumnsList = <TRow>(
  apiColumns: readonly IApiColumnConfig[],
  registry: Readonly<Record<string, IColumnRendererEntry<TRow>>>,
  getDataField: TGetDataField = defaultGetDataField,
): IColumnDefinition[] => apiColumns.map((apiCol) => resolveColumnFromApiConfig(
  apiCol,
  registry[apiCol.id],
  getDataField(apiCol.id),
));

export const resolveDataColumnsMap = <TRow>(
  apiColumns: readonly IApiColumnConfig[],
  registry: Readonly<Record<string, IColumnRendererEntry<TRow>>>,
  getDataField: TGetDataField = defaultGetDataField,
): ReadonlyMap<string, IColumnDefinition> => {
  const columnsById = new Map<string, IColumnDefinition>();

  for (const apiCol of apiColumns) {
    columnsById.set(apiCol.id, resolveColumnFromApiConfig(apiCol, registry[apiCol.id], getDataField(apiCol.id)));
  }

  return columnsById;
};

export const finalizeColumns = (ordered: readonly IColumnDefinition[]): IColumn[] => {
  const firstDataIndex = ordered.findIndex((col) => col.dataType !== 'checkbox');
  const lastDataIndex = ordered.findLastIndex((col) => col.dataType !== 'checkbox');

  return ordered.map((col, index) => ({
    name: col.name,
    title: col.title,
    width: col.width,
    minWidth: col.minWidth,
    maxWidth: col.maxWidth,
    sortable: col.sortable,
    tooltipContent: col.tooltipContent,
    tooltipMaxWidth: col.tooltipMaxWidth,
    isDraggable: col.isDraggable,
    className: cn(
      resolveAlignment(col.dataType, {
        isFirstDataColumn: index === firstDataIndex,
        isLastColumn: index === lastDataIndex,
        customAlign: col.customAlign,
      }),
      col.className,
    ),
    cellCallback: col.cellCallback,
  }));
};
